<template>
  <div class="modal-dim on"><!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="detail-view-modal">
          <div class="swiper mySwiper pd-side40">
            <div class="swiper-wrapper">
              <div class="swiper-slide swiper-slide-active">
                <img src="@/assets/static/images/main-modal.png" alt="">
                <!-- 영역 껍데기 버튼 -->
                <div style="position: absolute; bottom: 2.4rem; left: 50%; transform: translateX(-50%); display: flex; align-items: center;">
                  <button style="width: 11rem;  height: 4.6rem; margin-right: 1rem; text-indent: -999px;" @click="fnWord">캠페인 바로가기</button>
                  <button style="width: 11rem;  height: 4.6rem; text-indent: -999px;" @click="push('/more/notice/-1')">앱 소개 영상 바로가기</button>
                </div>
              </div>
            </div>
            <div class="swiper-button-close" @click="fnClose"></div>
            <div class="check-box widthFill mt10">
              <label class="checkbox">
                <input type="checkbox" :checked="state.isTodayHide" v-model="state.isTodayHide">
                <span class="check-txt" style="color: #FFFFFF;">오늘 하루 보지 않기</span>
              </label>
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from 'vue-router';
import { reactive } from 'vue';
import { useStore } from 'vuex';
const emits = defineEmits(['close']);
const { push } = useRouter()
const state = reactive({
  isTodayHide: false
})

const store = useStore();

const fnClose = async () =>{
  if (state.isTodayHide) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    const todayStr = `${yyyy}-${mm}-${dd}`;

    await store.commit('layout/setIsTodayExpireDate', todayStr);
  }
  await emits('close');
}

const fnWord = () => {
  push('/business/register/new') // 간소화 등록 (260414)
}

</script>


<style lang="scss">
.nav {
  z-index: 0 !important;
}
</style>
